import React from 'react';
import { Helmet } from 'react-helmet';

import { practiceProfilePropType } from './propTypes/index';

const dayOfWeek = [
  'http://schema.org/Monday',
  'http://schema.org/Tuesday',
  'http://schema.org/Wednesday',
  'http://schema.org/Thursday',
  'http://schema.org/Friday',
  'http://schema.org/Saturday',
  'http://schema.org/Sunday',
];

const openingHours = data =>
  Object.entries(data).map((day, index) => {
    if (day[1].o) {
      return {
        '@type': 'OpeningHoursSpecification',
        closes: day[1].c.substr(-8),
        dayOfWeek: dayOfWeek[index],
        opens: day[1].o.substr(-8),
      };
    }
    return null;
  });

const employees = data =>
  data.map(employee => ({
    '@type': 'Person',
    name: employee.Name,
    jobTitle: employee.Type,
  }));

const Markup = ({ practice }) => (
  <Helmet>
    <title>{practice.Name}</title>
    {practice.Description && (
      <meta name="description" content={practice.Description} />
    )}
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org/',
        '@type': 'Physician',
        address: {
          '@type': 'PostalAddress',
          streetAddress: practice.Address,
        },
        name: practice.Name,
        description: practice.Description,
        openingHoursSpecification: openingHours(practice.OpeningHours),
        image: practice.Pictures[0],
        priceRange: '$$',
        employees: employees(practice.Doctors),
      })}
    </script>
  </Helmet>
);

Markup.propTypes = { practice: practiceProfilePropType };

export default Markup;
